import React from 'react'
import * as Flags from '@veneer/flags'

const Flag = ({ country, disabled, size }) => {
  const SelectedFlag = Flags[`Flag${country.toUpperCase()}`]
  if (!SelectedFlag) {
    return <> </>
  }
  return (
    <SelectedFlag
      data-testid={`flag-${country}`}
      disabled={disabled}
      size={size}
    />
  )
}

export default Flag
